import { Input as AntInput } from 'antd'
import type { ChangeEvent, PropsWithChildren } from 'react'
import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'
import type { T_InputProps } from './input'


export const SC_InputAndLabelWrapper = styled(
  (p: PropsWithChildren<T_InputProps>) => (
    <div className={p.className}>
      {p.children}
    </div>
  )
)`
  display: flex;
  flex-direction: column;
  border-radius: ${(p) => (
    p.$isVeryRadiused ? '26px'
      : p.$customType === 'numeric' ? '10px'
        : '8px'
  )};
  width: 100%;
  background-color: ${(p) => (
    p.$isWhite ? E_Colors.White
      : E_Colors.GrayF2F2F7
  )};
  box-sizing: border-box;
  height: ${(p) => (
    p.$extraSize === 'veryLarge' ? '60px'
      : p.$customType === 'numeric' ? '54px'
        : '44px'
  )};
  padding: ${(p) => (
    p.$extraSize === 'veryLarge' ? '0 16px'
      : p.$customType === 'numeric' ? '0 12px'
        : '0 8px'
  )};
  justify-content: center;
  border: 1px solid #D0D0E7;
  ${(p) => p.disabled ? `border-color: ${E_Colors.GrayCC}` : ''};
  ${(p) => p.$minWidth ? `min-width: ${p.$minWidth}` : ''};

  label {
    font-size: 11px;
    padding-bottom: 4px;
    color: ${E_Colors.Gray66};
  }

  &:focus-within {
    border: 1px solid #9E6DEA;
  }
`

export const SC_InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 16px;
  font-weight: 500;

  [data-input-phone] {
    background-color: transparent !important;
    border: none !important;
    padding-left: 0;
    padding-right: 0;
    color: ${E_Colors.TextPrimary};
    outline: none !important;
    width: 100%;
    font-size: 16px;
  }

  [data-input-date] {
    background-color: transparent !important;
    border: none !important;
    padding-left: 0;
    padding-right: 0;
    color: ${E_Colors.TextPrimary};
    outline: none !important;
    width: 100%;
    font-size: 14px;
  }

  [data-input-date]::placeholder {
    color: ${E_Colors.GrayB2};
  }
`

export const SC_Input = styled(
  (p: T_InputProps) => {
    const {
      name,
      setFormValue,
      onChange,
      $ref,
      ...restProps
    } = p


    return (
      <AntInput
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          onChange?.(e)
          setFormValue?.(name!, e.currentTarget.value)
        }}
        ref={$ref as any}
        name={name}
        {...restProps}
      />
    )
  }
)`
  background-color: transparent !important;
  border: none !important;
  border-radius: 0;
  font-size: ${(p) => p.$customType === 'numeric' ? '16px' : '14px'};
  padding-left: 0;
  padding-right: 0;
  color: ${E_Colors.TextPrimary};
  box-shadow: none !important;
  line-height: normal;

  &.ant-input-disabled {
    background-color: ${E_Colors.GrayF0};
    color: ${E_Colors.Gray66};
  }

  input {
    background-color: transparent !important;
    ${(p) => p.$frameStyle === 'framed' ? `
      border: 0;
      height: 22px;
      padding: 0;
    ` : ''};
  }
`
